/** The person's preference that says they finished (or skipped) the first-run setup. */
const PIEVE_ONBOARDING_FINISHED_PREF_KEY = 'pieve.onboarding.hasFinishedOnboarding';

export default PIEVE_ONBOARDING_FINISHED_PREF_KEY;
